import { IKnmKind } from 'APIPackage/DictionariesModule/interfaces/IKnmKind';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryKnmKindSelectOption = makeCreateDictionarySelectOption<IKnmKind>('guid', 'title');
